/**
 * Client mirror of `server/middleware/adminRole.ts`. The server is the
 * enforcement point (staff get 403 from the QuickBooks financial endpoints);
 * this only hides UI that would otherwise render an empty/error state.
 *
 * `adminUser` is refreshed from /admin/verify-session by AdminRoute on every
 * admin page load, so the role here tracks the server's view of the user.
 */
export function getAdminRole(): string | null {
  try {
    const raw = sessionStorage.getItem("adminUser");
    return raw ? (JSON.parse(raw).role ?? null) : null;
  } catch {
    return null;
  }
}

export function canViewFinancials(): boolean {
  const role = getAdminRole();
  return role === "admin" || role === "super_admin";
}
